import React, { createContext, useContext } from "react";
import type { MutableRefObject } from "react";

type ShareContextType = {
  statusCode: number;
  setStatusCode: React.Dispatch<React.SetStateAction<number>>;
  listingDetailShareUrlRef: MutableRefObject<string | null>;
};

export const ShareContext = createContext<ShareContextType | undefined>(
  undefined,
);

// Custom hook to use the ShareContext
export const useShareContext = () => {
  const context = useContext(ShareContext);
  if (!context) {
    throw new Error(
      "useShareContext must be used within a ShareContextProvider",
    );
  }
  return context;
};
